const SEGMENT_CDN_HOST = "cdn.segment.com";
const PATCH_FLAG = "__memSegmentCrossOriginPatched__";

const shouldApplyCrossOrigin = (script: HTMLScriptElement, src: string): boolean => {
  if (script.crossOrigin || script.getAttribute("crossorigin")) {
    return false;
  }

  try {
    const baseHref =
      script.ownerDocument?.baseURI ??
      (typeof document !== "undefined" ? document.baseURI : undefined);

    if (!baseHref) {
      return false;
    }

    const resolved = new URL(src, baseHref);
    return resolved.hostname === SEGMENT_CDN_HOST;
  } catch {
    return false;
  }
};

export const ensureSegmentScriptCrossOrigin = (): void => {
  if (typeof window === "undefined" || typeof HTMLScriptElement === "undefined") {
    return;
  }

  const prototype = HTMLScriptElement.prototype as HTMLScriptElement & {
    [PATCH_FLAG]?: boolean;
  };

  if (prototype[PATCH_FLAG]) {
    return;
  }

  const descriptor = Object.getOwnPropertyDescriptor(prototype, "src");
  if (!descriptor?.set || !descriptor.get) {
    return;
  }

  const originalSetter = descriptor.set;

  // Segment bootstraps by creating a <script> element and setting its src directly.
  // We intercept that assignment to ensure the request is made with CORS enabled,
  // which keeps the bundle compatible with COOP/COEP.
  Object.defineProperty(prototype, "src", {
    configurable: descriptor.configurable ?? true,
    enumerable: descriptor.enumerable ?? false,
    get: descriptor.get,
    set(value: string) {
      if (typeof value === "string" && shouldApplyCrossOrigin(this, value)) {
        this.crossOrigin = "anonymous";
      }
      originalSetter.call(this, value);
    },
  });

  Object.defineProperty(prototype, PATCH_FLAG, {
    value: true,
    configurable: false,
    enumerable: false,
    writable: false,
  });
};
